import { MOKA_FRESH_API } from 'api/constants';

export const FRESH_CUSTOMER_URL = `${MOKA_FRESH_API}/customers`;
